import React, { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';
import { useUser } from '../context/UserContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const QuickCompanyDialog = ({ open, onOpenChange, companyType, onSuccess }) => {
  const { currentUser } = useUser();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    website: '',
    notes: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name.trim()) {
      toast.error('El nombre de la empresa es obligatorio');
      return;
    }

    setLoading(true);
    try {
      const payload = {
        name: formData.name.trim(),
        company_type: companyType, // 'privada' or 'publica'
        website: formData.website || null,
        notes: formData.notes || null,
      };

      const response = await axios.post(`${API}/companies`, payload, {
        headers: { 'X-User-Email': currentUser?.email }
      });
      
      toast.success(`Empresa ${companyType === 'privada' ? 'privada' : 'pública'} creada`);
      onSuccess(response.data);
      onOpenChange(false);
      setFormData({ name: '', website: '', notes: '' });
    } catch (error) {
      console.error('Error creating company:', error);
      toast.error(error.response?.data?.detail || 'Error al crear la empresa');
    } finally {
      setLoading(false);
    }
  };

  const typeLabel = companyType === 'privada' ? 'Privada' : 'Pública';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md max-h-[90vh] overflow-y-auto" data-testid="quick-company-dialog">
        <DialogHeader>
          <DialogTitle>Nueva Empresa {typeLabel}</DialogTitle>
        </DialogHeader>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="company-name">Nombre de la Empresa *</Label>
            <Input
              id="company-name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="Nombre de la empresa"
              data-testid="quick-company-name"
              autoFocus
            />
          </div>
          
          <div>
            <Label htmlFor="company-website">Sitio Web</Label>
            <Input
              id="company-website"
              type="url"
              value={formData.website}
              onChange={(e) => setFormData({ ...formData, website: e.target.value })}
              placeholder="https://www.ejemplo.com"
              data-testid="quick-company-website"
            />
          </div>
          
          <div>
            <Label htmlFor="company-notes">Notas</Label>
            <Textarea
              id="company-notes"
              value={formData.notes}
              onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
              placeholder="Notas adicionales sobre la empresa"
              rows={2}
              data-testid="quick-company-notes"
            />
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button type="submit" disabled={loading} data-testid="quick-company-save">
              {loading ? 'Creando...' : 'Crear Empresa'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default QuickCompanyDialog;
